export default {
    m: 660,
    l: 900,
    xl: 1280,
};
